export default "__VITE_ASSET__BqRFJAS8__"